import { useCallback, useEffect, useState } from "react";
import EmailTemplateService, {
  EmailTemplateListResponse
} from "../../../services/EmailTemplateService";
import ErrorMessage from "../../shared/components/Error";
import Loading from "../../shared/components/Loading";
import FloatingPanelService from "../../shared/FloatingPanel";
import { TranslationService } from "../../../services/TranslationService";
import EmailTemplateEdit from "./EmailTemplateEdit";

const EmailTemplateConfiguration = () => {
  const { translate } = TranslationService;
  const [response, setResponse] = useState<EmailTemplateListResponse>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const requestData = async () => {
    const result = await EmailTemplateService.getList();
    if (result instanceof Error) {
      setError(true);
      setLoading(false);
      return;
    }
    setResponse(result);
    setLoading(false);
    setError(false);
  };

  const requestDataCallback = useCallback(requestData, []);
  useEffect(() => {
    requestDataCallback();
  }, [requestDataCallback]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <ErrorMessage
        onRefresh={requestDataCallback}
        message={translate.ErrorLoadingList}
      />
    );
  }

  const showEmailTemplateEditModal = (
    EmailTemplate?: EmailTemplateListResponse["list"][number]
  ) => {
    FloatingPanelService.showPanel({
      children: (
        <EmailTemplateEdit
          reload={requestDataCallback}
          current={EmailTemplate}
        />
      ),
      title: translate.EmailTemplates,
      width: 600,
      height: 600,
      position: "center"
    });
  };

  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <h4 className="mb-2">{TranslationService.translate.EmailTemplates}</h4>
        <div className="card">
          <div className="d-flex align-items-center justify-content-end mb-2 gap-2">
            <button
              className="btn btn-primary"
              onClick={() => showEmailTemplateEditModal(undefined)}
            >
              <i className="fal fa-plus" /> {translate.AddNewTemplate}
            </button>
          </div>
          <table className="table shadow-hover">
            <thead>
              <tr>
                <th>{translate.Template}</th>
                <th>{translate.Subject}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {response?.list.map((x) => (
                <tr
                  key={x.MailTemplateID}
                  className="pointer"
                  onClick={() => showEmailTemplateEditModal(x)}
                >
                  <td>{x.Name}</td>
                  <td>{x.Subject}</td>
                  <td width={200}>
                    <button className="edit">
                      <i className="far fa-pen undefined"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default EmailTemplateConfiguration;
